import React from 'react';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';
import Cookies from 'universal-cookie';
import { withRouter } from 'react-router-dom';

const cookies = new Cookies();

class Register extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'',
            last_name:'',
            email:'',
            phone_number:'',
            password:'',
            password_confirmation:'',
            loading:false,
            message_serve:'',
            message_serve_e:''
        }
    }
    handleChange=(e)=>{
        this.setState({
            [e.target.name] : e.target.value
        });
    
    }
    handleSubmit=(e)=>{
        this.setState({message_serve_e:"",loading:true});
        e.preventDefault();
        API.PRODUCTS.post('register_users_arqui',{
            name:this.state.name,
            last_name:this.state.last_name,
            email:this.state.email,
            phone_number:this.state.phone_number,
            password:this.state.password,
            password_confirmation:this.state.password_confirmation,
        })
        .then(response=>{
            this.setState({
                loading:false
            })
            //console.log(response);
            if(response.data.message=="error"){
               // alert('El usuario o la contraseña no son correctos');
                this.setState({
                    message_serve_e:"Rellene bien los datos",
                    loading:false
                })
            }else{
                
            return response;
            }
        })
        .then(response=>{
            //console.log(response);
            if(response.status==200){
                
                var respuesta=response.data;
                cookies.set('id', respuesta.id, {path: "/"});
                cookies.set('name', respuesta.name, {path: "/"});
                cookies.set('last_name', respuesta.last_name, {path: "/"});
                cookies.set('email', respuesta.email, {path: "/"});
                cookies.set('pais', respuesta.pais, {path: "/"});
                cookies.set('address', respuesta.address, {path: "/"});
                cookies.set('distrito', respuesta.distrito, {path: "/"});
                cookies.set('doc_number', respuesta.doc_number, {path: "/"});
                cookies.set('phone_number', respuesta.phone_number, {path: "/"});
                cookies.set('url_photo', respuesta.url_foto, {path: "/"});
                window.location.href="/";
                
            }else{
                this.setState({loading:false,message_serve_e:"asegúrese de llenar bien los datos"});
            }
        })
        .catch(err => {
            console.log(err);
            this.setState({loading:false,message_serve_e:"asegúrese de llenar bien los datos"});
                //console.log(err.error);
            
        })
    }
    
    componentDidMount() {
        if(cookies.get('id')){
           window.location.href="/";
        }
    }
    
    render(){
        return(
            <div className="container-fluid mt-2 mb-3">
            <div className="col-12">
                <div className="login col-lg-3 col-md-6 col-sm-8 col-xs-12 mx-auto"> 
                    <div><img src="/assets/a.png"></img></div> 
                    <h5 className="text-center">REGISTRATE AHORA</h5>
                    <div className="d-flex justify-content-center">
                                {this.state.loading==true
                                ?
                                    <BarLoader
                                        width={100}
                                        height={4}
                                        color={APP_CONFIG.spinner_color}
                                        loading={this.state.loading}
                                    />
                                :""}
                                    {this.state.message_serve_e!==''&&
                                    <div className="error">{this.state.message_serve_e}</div>
                                    }
                                    
                            </div>
                    <form id="login" onSubmit={this.handleSubmit} className="form-login">
                        
                    <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="text" onChange={this.handleChange} className="form-control" id="name" name="name" placeholder="Nombre" required />                 
                            </div>                
                        </section>
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="text" onChange={this.handleChange} className="form-control" id="last_name" name="last_name" placeholder="Apellidos" required />                 
                            </div>                
                        </section>
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="number" onChange={this.handleChange} className="form-control" id="phone_number" name="phone_number" placeholder="Teléfono" required />                 
                            </div>                
                        </section>
                        
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="email" onChange={this.handleChange} className="form-control" id="email" name="email" placeholder="Email" required />                 
                            </div>                
                        </section>
                       {/* <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="text" onChange={this.handleChange} className="form-control" id="nombre" name="full_name" placeholder="Pais (opcional)" required />                 
                            </div>                
                        </section>
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="text" onChange={this.handleChange} className="form-control" id="nombre" name="full_name" placeholder="Distrito (opcional)" required />                 
                            </div>                
                        </section>
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="text" onChange={this.handleChange} className="form-control" id="nombre" name="full_name" placeholder="Dirección (opcional)" required />                 
                            </div>                
                        </section>
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="text" onChange={this.handleChange} className="form-control" id="nombre" name="full_name" placeholder="Teléfono" required />                 
                            </div>                
                        </section>
                        */}
                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="password" onChange={this.handleChange} className="form-control" name="password" id="password" placeholder="Contraseña" required/>
                            </div>                
                        </section>

                        <section className="col-xs-12 col-md-12">
                            <div className="form-group">                  
                            <input type="password" onChange={this.handleChange} className="form-control" name="password_confirmation" id="password_confirmation" placeholder="Confirmar contraseña" required/>
                            </div>                
                        </section>
                        
                                   
                        <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input" id="check" required/>
                        <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Acepto los <a type="button" className="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModalterminos">Términos y Condiciones</a>.</label>              
                        </div> 
                        
                        
                        <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input" id="check" required/>
                        <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}> Al marcar ésta casilla acepto la <a type="button" className="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModalpolitica"> Política de protección de datos personales</a> . </label>              
                        </div>

                        
                                


                        <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input" id="check" required/>
                        <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Autorizo el tratamiento de mis datos personales para recibir ofertas y comunicaciones comerciales por parte de esta empresa.</label>              
                        </div>
                        
                          <button type="submit" className="btn">Registrar</button>
                          <p className="text-center p-register"></p>
                      
                        
                    </form>
                </div> 
            </div>
        </div>
        )
    }
}

export default Register;
